import { ModalBaseDirective } from '$core/base/_modal.component';
import { AfterViewInit, Component } from '@angular/core';
@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent
  extends ModalBaseDirective
  implements AfterViewInit
{
  public title = 'ARE_YOU_SURE';
  public text: string;
  public data?: any;
  public confirmBtn = 'CONFIRM';
  public declineBtn = 'DECLINE';
  public hideCloseBtn: boolean;
  public showSpinner: boolean;

  public ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.showSpinner) {
      this.showSpinner = false;
      setTimeout(() => {
        this.showSpinner = true;
      }, 0);
    }
  }
}
